// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { i18n } from '@/plugins'
// import moment from 'moment'

export const MENU = [
  {
    title: i18n.t('dashboard.arrival_sales.title') as string,
    icon: 'mdi-flower-pollen',
    children: [
      {
        title: i18n.t('dashboard.arrival_sales.arrival_input') as string,
        path: '/arrival-input'
      },
      {
        title: i18n.t('menu.sales') as string,
        path: '/sales'
      },
      {
        title: i18n.t('dashboard.arrival_sales.akakuro_arrival') as string,
        path: '/akakuro-sales'
      }
    ]
  },
  {
    title: i18n.t('dashboard.data_link.title') as string,
    icon: 'mdi-database-sync-outline',
    children: [
      {
        title: i18n.t('dashboard.data_link.akita_data_link') as string,
        path: '/akita-integration',
        query: { code: '1' }
      },
      {
        title: i18n.t('dashboard.data_link.faj_data_link') as string,
        path: '/faj-integration',
        query: { code: '3' }
      },
      {
        title: i18n.t('dashboard.data_link.setagata_data_link') as string,
        path: '/sk-integration',
        query: { code: '55' }
      },
      {
        title: i18n.t('dashboard.data_link.morioka_data_link') as string,
        path: '/morioka-integration',
        query: { code: '11' }
      },
      {
        title: i18n.t('dashboard.data_link.classic_data_link') as string,
        path: '/classic-integration',
        query: { code: '9' }
      }
    ]
  },
  {
    title: i18n.t('dashboard.export.title') as string,
    icon: 'mdi-printer-outline',
    children: [
      {
        title: i18n.t('menu.export_label') as string,
        path: '/export-label'
      },
      {
        title: i18n.t('menu.export_peddler_sales') as string,
        path: '/export-peddler-sales'
      },
      {
        title: i18n.t('menu.export_buyer_sales') as string,
        path: '/export-buyer-sales'
      },
      {
        title: i18n.t('menu.export_bill') as string,
        path: '/export-bill'
      }
    ]
  },
  {
    title: i18n.t('dashboard.inquiry.title') as string,
    icon: 'mdi-file-search-outline',
    children: [
      {
        title: i18n.t('menu.arrival_inquiry') as string,
        path: '/arrival-inquiry'
      },
      {
        title: i18n.t('menu.sales_inquiry') as string,
        path: '/sales-inquiry'
      },
      {
        title: i18n.t('menu.stock_report') as string,
        path: '/stock-report'
      },
      {
        title: i18n.t('menu.file_management') as string,
        path: '/master/file-management'
      }
    ]
  },

  {
    title: i18n.t('dashboard.accounting.title') as string,
    icon: 'mdi-credit-card-outline',
    children: [
      {
        title: i18n.t('dashboard.accounting.account_receivable') as string,
        path: '/account-receive'
      },
      {
        title: i18n.t('dashboard.accounting.deposit') as string,
        path: '/deposit'
      },
      {
        title: i18n.t('dashboard.accounting.account_payable') as string,
        path: '/account-payable'
      },
      {
        title: i18n.t('dashboard.accounting.payment') as string,
        path: '/payment'
      }
    ]
  },
  {
    title: i18n.t('dashboard.daily_update.title') as string,
    icon: 'mdi-calendar-sync',
    children: [
      {
        title: i18n.t('menu.daily_update') as string,
        path: '/daily-update'
      },
      {
        title: i18n.t('dashboard.daily_update.mailing') as string,
        path: '/mail-delivery'
      }
    ]
  },
  {
    title: i18n.t('dashboard.master.title') as string,
    icon: 'mdi-flower-pollen',
    children: [
      {
        title: i18n.t('dashboard.master.buyer') as string,
        path: '/master/buyer'
      },
      {
        title: i18n.t('dashboard.master.supplier') as string,
        path: '/master/supplier'
      },
      {
        title: i18n.t('dashboard.master.partner') as string,
        path: '/master/partner'
      },
      {
        title: i18n.t('dashboard.master.shipper') as string,
        path: '/master/shipper'
      },
      {
        title: i18n.t('dashboard.master.item') as string,
        path: '/master/items'
      },
      {
        title: i18n.t('dashboard.master.variety') as string,
        path: '/master/varieties'
      },
      {
        title: i18n.t('dashboard.master.grade') as string,
        path: '/master/grade'
      },
      {
        title: i18n.t('dashboard.master.rank') as string,
        path: '/master/rank'
      },
      {
        title: i18n.t('dashboard.master.packing') as string,
        path: '/master/packing'
      },
      {
        title: i18n.t('dashboard.master.calendar') as string,
        path: '/master/calendar',
        adminOnly: true
      },
      {
        title: i18n.t('dashboard.master.settings') as string,
        path: '/master/setting',
        adminOnly: true
      },
      {
        title: i18n.t('dashboard.master.member') as string,
        path: '/master/member',
        adminOnly: true
      },
      {
        title: i18n.t('dashboard.master.login') as string,
        path: '/master/login',
        adminOnly: true
      }
    ]
  }
]
